function Home2() {
  return (
    <>
      <div className="banner banner-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 mb-4">
              <div className="banner-content-wrapper banner-padding">
                <div className="banner-content">
                  <h1 className="banner-title">Myhilight.io introfuction</h1>
                  <p className="banner-des">
                    Myhilight.io is a platform where individuals can create,
                    buy, or sell NFT’s. After the NFT is created, individuals
                    can auction their highlight or keep it as a memory. Our
                    customers who interface with our platform will have an
                    opportunity to integrate their NFT’s with their media,
                    social media, ecosystems, and any other applications.
                    Customers can use their applications to monitor NFT’s sale
                    and digital currency. Our business model is for individuals
                    with influential reach and businesses with ecosystems to
                    engage and monetize their consumer bases. Our business model
                    is
                  </p>

                  <div className="banner-button-area">
                    <a href="" className="custom-btn me-2">
                      <span>Mint Now</span>
                    </a>
                    <a href="" className="custom-btn-alt">
                      <span>Learn More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 mb-4">
              <div className="banner-img">
                <img src="assets/img/banner/5.png" alt="banner-img" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="big-bg-area">
        <section>
          <div className="about-sec cpy-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <div className="about-img-T">
                    <img src="assets/img/inner/22.png" alt="" />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="about-content">
                    <div className="about-content-inn">
                      <h2 className="about-title">
                        NFT & Cryptocurrency Industry
                      </h2>
                      <div className="about-list">
                        <ul className="about-list-ul">
                          <li>
                            <p>
                              The NFT Market is evaluated at over 10 billion in
                              2021 and is expected to 4x in 2022.
                            </p>
                          </li>
                          <li>
                            <p>
                              The NFT industry is growing by 100% each month.
                            </p>
                          </li>
                          <li>
                            <p>
                              Industries like gaming, art, music, and sports are
                              finding use cases for NFT’s
                            </p>
                          </li>
                          <li>
                            <p>
                              The Most Expensive NFT Ever Sold was 69 million
                              dollars.
                            </p>
                          </li>
                          <li>
                            <p>The NFT market does 450,000 dollars a day.</p>
                          </li>
                          <li>
                            <p>
                              The use cases for the NFT industry are endless and
                              will increase with time.
                            </p>
                          </li>
                          <li>
                            <p>
                              The crypto market currently circulates over 2
                              trillion dollars a day.
                            </p>
                          </li>
                          <li>
                            <p>
                              There are over 300 global exchanges for
                              cryptocurrency.
                            </p>
                          </li>
                          <li>
                            <p>
                              Global Banks and major businesses are adding the
                              ability to transact crypto.
                            </p>
                          </li>
                          <li>
                            <p>
                              Crypto.com says global crypto wallets have passed
                              200 million August 2021.
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* =====================solution==================== */}
        <section>
          <div className="solutions-section">
            <div className="container">
              <div className="row">
                <div className="sec-title-n">
                  <h2>Myhilight Solutions</h2>
                  <h5>NFT & Cryptocurrency Industry</h5>
                  <p>
                    Participate in selling NFT’s in a global marketplace
                    marketing their auction to consumer base and global NFT
                    platforms.
                  </p>
                </div>
              </div>
            </div>

            <div className="solution-area">
              <div className="images-slider-wrapper">
                <div className="images-slider-imgs">
                  <img src="assets/img/solutions/1.png" alt="" />
                  <img src="assets/img/solutions/2.png" alt="" />
                  <img src="assets/img/solutions/3.png" alt="" />
                  <img src="assets/img/solutions/4.png" alt="" />
                  <img src="assets/img/solutions/5.png" alt="" />
                  <img src="assets/img/solutions/6.png" alt="" />
                  <img src="assets/img/solutions/7.png" alt="" />
                </div>

                <div className="images-slider-imgs">
                  <img src="assets/img/solutions/1.png" alt="" />
                  <img src="assets/img/solutions/2.png" alt="" />
                  <img src="assets/img/solutions/3.png" alt="" />
                  <img src="assets/img/solutions/4.png" alt="" />
                  <img src="assets/img/solutions/5.png" alt="" />
                  <img src="assets/img/solutions/6.png" alt="" />
                  <img src="assets/img/solutions/7.png" alt="" />
                </div>

                <div className="images-slider-imgs">
                  <img src="assets/img/solutions/1.png" alt="" />
                  <img src="assets/img/solutions/2.png" alt="" />
                  <img src="assets/img/solutions/3.png" alt="" />
                  <img src="assets/img/solutions/4.png" alt="" />
                  <img src="assets/img/solutions/5.png" alt="" />
                  <img src="assets/img/solutions/6.png" alt="" />
                  <img src="assets/img/solutions/7.png" alt="" />
                </div>
              </div>

              <div className="images-slider-wrapper">
                <div className="images-slider-imgs">
                  <img src="assets/img/solutions/1.png" alt="" />
                  <img src="assets/img/solutions/2.png" alt="" />
                  <img src="assets/img/solutions/3.png" alt="" />
                  <img src="assets/img/solutions/4.png" alt="" />
                  <img src="assets/img/solutions/5.png" alt="" />
                  <img src="assets/img/solutions/6.png" alt="" />
                  <img src="assets/img/solutions/7.png" alt="" />
                </div>

                <div className="images-slider-imgs">
                  <img src="assets/img/solutions/1.png" alt="" />
                  <img src="assets/img/solutions/2.png" alt="" />
                  <img src="assets/img/solutions/3.png" alt="" />
                  <img src="assets/img/solutions/4.png" alt="" />
                  <img src="assets/img/solutions/5.png" alt="" />
                  <img src="assets/img/solutions/6.png" alt="" />
                  <img src="assets/img/solutions/7.png" alt="" />
                </div>

                <div className="images-slider-imgs">
                  <img src="assets/img/solutions/1.png" alt="" />
                  <img src="assets/img/solutions/2.png" alt="" />
                  <img src="assets/img/solutions/3.png" alt="" />
                  <img src="assets/img/solutions/4.png" alt="" />
                  <img src="assets/img/solutions/5.png" alt="" />
                  <img src="assets/img/solutions/6.png" alt="" />
                  <img src="assets/img/solutions/7.png" alt="" />
                </div>
              </div>

              <div className="hil">
                <img src="assets/img/solutions/bg.png" alt="" />
              </div>
            </div>
          </div>
        </section>
        {/* ====================solution end=================== */}
        {/* =====================personal====================== */}
        <section>
          <div className="customized-area cpt-6">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <div className="about-content">
                    <div className="about-content-inn">
                      <h2 className="about-title">Personal & Customized</h2>
                      <div className="about-list">
                        <ul className="about-list-ul">
                          <li>
                            <p>
                              Create a store that reflects your brand inside of
                              your own ecosystem and position your business to
                              benefit from a trillion dollar a day industry.
                            </p>
                          </li>
                          <li>
                            <p>
                              Our website is designed for consumers to
                              customization.
                            </p>
                          </li>
                          <li>
                            <p>
                              NFT stores are able to integrate with social media
                              profiles consumer base marketing.
                            </p>
                          </li>
                          <li>
                            <p>
                              Colleges will be able to create stores to profit
                              share with their athletes.
                            </p>
                          </li>
                          <li>
                            <p>
                              Highschool athletes will have an opportunity to
                              sell their NFT’s and maintain college eligibility
                              in states what have not changed college
                              eligibility rules.
                            </p>
                          </li>
                          <li>
                            <p>
                              Influencers, Athletes, Businesses and others will
                              be able to use our professional services to create
                              NFT’s.
                            </p>
                          </li>
                          <li>
                            <p>
                              Ability to create a revenue share or split sales
                              between two or more entities for NFT sales.
                            </p>
                          </li>
                          <li>
                            <p>
                              Residual income ability for multiple sales of
                              NFT’s.
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="customized-img">
                    <img src="assets/img/inner/23.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =====================personal end====================== */}
        {/* =====================myhilight====================== */}
        <section>
          <div className="myhilight-area cpy-8">
            <div className="container">
              <div className="row">
                <div className="sec-title-n">
                  <h2>Why Join Myhilight.com</h2>
                </div>
              </div>
              <div className="myhilight-content cpy-5">
                <div className="row">
                  <div className="col-lg-4 mb-4">
                    <div className="join-list">
                      <ul className="join-list-ul left-list">
                        <li>
                          <p>Ability to add a Personal Touch to your store.</p>
                          <img
                            src="assets/img/icon/arrow-a.svg"
                            alt=""
                            className="arrow-a"
                          />
                        </li>

                        <li>
                          <p>NFTs are in high demand.</p>
                          <img
                            src="assets/img/icon/arrow-a.svg"
                            alt=""
                            className="arrow-a"
                          />
                        </li>
                        <li>
                          <p>
                            NFT’s and Tokens designed for each customer to
                            establish brand recognition.
                          </p>
                          <img
                            src="assets/img/icon/arrow-a.svg"
                            alt=""
                            className="arrow-a"
                          />
                        </li>
                        <li>
                          <p>Be involved in a billion-dollar industry.</p>
                          <img
                            src="assets/img/icon/arrow-a.svg"
                            alt=""
                            className="arrow-a"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-4 mb-4">
                    <div className="join-img">
                      <img src="assets/img/product/11.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-4 mb-4">
                    <div className="join-list">
                      <ul className="join-list-ul ">
                        <li>
                          <img
                            src="assets/img/icon/arrow-b.svg"
                            alt=""
                            className="arrow-a"
                          />
                          <p>
                            A way for your business to gain traction among the
                            crypto community.
                          </p>
                        </li>
                        <li>
                          <img
                            src="assets/img/icon/arrow-b.svg"
                            alt=""
                            className="arrow-a"
                          />
                          <p>
                            NFTs create scarcity and grow in value as you build
                            your brand
                          </p>
                        </li>
                        <li>
                          <img
                            src="assets/img/icon/arrow-b.svg"
                            alt=""
                            className="arrow-a"
                          />
                          <p>Expand your financial portfolio.</p>
                        </li>
                        <li>
                          <img
                            src="assets/img/icon/arrow-b.svg"
                            alt=""
                            className="arrow-a"
                          />
                          <p>Create new income streams.</p>
                        </li>
                        <li>
                          <img
                            src="assets/img/icon/arrow-b.svg"
                            alt=""
                            className="arrow-a"
                          />
                          <p>
                            NFTs can be great PR campaigns for business or
                            personal.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =====================myhilight end====================== */}

        {/* =============use cases======================= */}
        <section>
          <div className="use-cases cpb-6">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 mb-4">
                  <div className="cases-img">
                    <img src="assets/img/product/12.png" alt="" />
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="cases-content">
                    <div class="content-inner">
                      <h2 class="about-title">NFT Use Cases</h2>

                      <ul className="cases-list">
                        <li>
                          <p>NFT minting for influencers and athletes.</p>
                        </li>
                        <li>
                          <p>
                            Gives the right to enter and use the services in the
                            ecosystem.
                          </p>
                        </li>
                        <li>
                          <p>
                            Video, Music, Art, Collectables, and Photography.
                          </p>
                        </li>
                        <li>
                          <p>
                            Carries mechanisms to prevent the token price from
                            dropping on exchanges.
                          </p>
                        </li>
                        <li>
                          <p>
                            The token has a comprehensible, attainable, and real
                            use cases which is
                          </p>
                        </li>
                        <li>
                          <p>integrated into an efficient protocol.</p>
                        </li>
                        <li>
                          <p>
                            Myhilight provides some rewards for its users
                            through referrals and NFT sales.
                          </p>
                        </li>
                        <li>
                          <p>
                            The ecosystem has a strong community, reputation,
                            and adoption
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =============use cases end======================= */}

        {/* =============functionalities section===================== */}
        <section>
          <div className="functionalities-section">
            <div className="container">
              <div className="row">
                <div className="sec-title text-center">
                  <h2 className="l-title">
                    Myhilight Systems and <br /> Functionalities
                  </h2>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 mb-4">
                  <div className="functionalities-list">
                    <div className="function-card-title">
                      <h2>Storefronts and Main Pages</h2>
                      <p>
                        We will contain information about new and trending NFTs
                        in our ecosystem
                      </p>
                    </div>
                    <div className="absulate-img">
                      <img src="assets/img/inner/1.svg" alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="functionalities-list">
                    <div className="function-card-title function-right">
                      <h2>Search And Filters</h2>
                      <p>
                        Visitors will have a clean and relaxed experience
                        searching for price, sorting mechanism, categories,
                        latest and greatest, etc.
                      </p>
                    </div>
                    <div className="absulate-img right">
                      <img src="assets/img/inner/2.svg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =============functionalities section end===================== */}
        {/* =================action features======================== */}
        <section>
          <div className="action-features cpy-8">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mb-4 mb-4">
                  <div class="cases-content">
                    <div className="content-inner">
                      <h2 class="about-title">Buy And Auction Features</h2>
                      <ul class="cases-list mb-5">
                        <li>
                          <p>
                            1) Minting - All NFTs are created and secured by
                            blockchain. Only allowed users can mint tokens.
                            There is a granting procedure that verifies an NFT
                            creator candidate and grants him permission of
                            creating NFT.
                          </p>
                        </li>
                        <li>
                          <p>
                            2) Listing - When NFT is minted, it does not mean
                            that it is ready for sale. Minted NFT is visible
                            only for their authors but not for buyers or other
                            interested parties. After an owner of NFT lists it,
                            it becomes available for sale.
                          </p>
                        </li>
                        <li>
                          <p>3) NFT types</p>
                        </li>
                        <li>
                          <p>
                            a) Minted — visible only to a consumer who owns this
                            token.
                          </p>
                        </li>
                        <li>
                          <p>
                            b) Reserve price — listed with a reserve price, but
                            no one has placed a bid on the auction yet. It might
                            be listed as both an author and a fan.
                          </p>
                        </li>
                        <li>
                          <p>
                            c) On Auction — listed with a reserve price and the
                            auction has started.
                          </p>
                        </li>
                        <li>
                          <p>
                            It might be listed as both an author and a fan, but
                            only a fan can make a bid.
                          </p>
                        </li>
                      </ul>
                      <a href="" className="custom-btn">
                        <span>learn more</span>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4 mb-4">
                  <div className="features-img">
                    <img src="assets/img/inner/24.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =================action features end ======================== */}

        {/* =================action features======================== */}
        <section>
          <div className="action-features cpy-8">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mb-4 mb-4">
                  <div className="features-img">
                    <img src="assets/img/inner/25.png" alt="" />
                  </div>
                </div>
                <div className="col-lg-6 mb-4 mb-4">
                  <div class="cases-content">
                    <div className="content-inner">
                      <h2 class="about-title">Revenue Creation</h2>
                      <ul class="cases-list mb-5">
                        <li>
                          <p>
                            Sale of an NFT will generate a 3.5% commission for
                            the Myhilight platform To open a store potential
                            potential store owners and NFT creators must be
                            referred to platform. Referral will trigger a .5%
                            fee of the 3.0% transaction of the NFT sale.
                          </p>
                        </li>
                        <li>
                          <p>Digital Art services ( NFT creation )</p>
                        </li>
                        <li>
                          <p>
                            Marketing and media Promotion in sale of NFT’s and
                            other marketing services.
                          </p>
                        </li>
                        <li>
                          <p>
                            Market consulting, product, global relations
                            introductions and brand development.
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =================action features end ======================== */}

        {/* =====================token=============== */}
        <section>
          <div className="token mb-5">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div class="sec-title-n">
                    <h2 className="mb-3">
                      Unity Token Kick Off and Token Sale
                    </h2>
                    <p>
                      To kickstart Unity Token there will be a capped number of
                      token of will be sold based on a predetermined price
                      function that increases over time. The capital raised from
                      the initial sale will be transferred to fund the
                      development of the ecosystem. The Token Launch will be
                      developed in two phases, Presale and platform integration
                      and implementation. Funding will be our partner in terms
                      of token issuance, distribution, and escrow.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =====================token end=============== */}
        {/* ======================token allocation===================== */}
        <section>
          <div className="allocation cpt-6">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <div className="allocation-content">
                    <div class="cases-content">
                      <div className="content-inner">
                        <h2 class="about-title">Token Allocation</h2>
                        <h5>Token Supply:</h5>
                        <ul class="cases-list mb-5">
                          <li>
                            <p>
                              A maximum of 500,000,000,000 token will be issued
                            </p>
                          </li>
                          <li>
                            <p>
                              Pre-Sale and Open Token Sale has already received
                              investment from strategic partners in order to
                              begin the development of our ecosystem and
                              specifically our crowd sale.
                            </p>
                          </li>
                          <li>
                            <p>
                              65% of tokens will be placed inside of the global
                              ecosystem.
                            </p>
                          </li>
                          <li>
                            <p>
                              15% will be of currency will be placed on
                              decentralized trade platforms.
                            </p>
                          </li>
                          <li>
                            <p>
                              10% - Of Currency Token is team and advisors -
                              This pool will also account for the founding team
                              and advisors and business that participate in the
                              ecosystem. Currency will be given to Strategic
                              Partnerships to create global relationships.
                            </p>
                          </li>
                          <li>
                            <p>
                              5% - Marketing, Bounty and Strategic Partnerships
                              - The marketing pool will be used to increase
                              awareness of our products and ecosystem
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="allocation-img">
                    <img src="assets/img/inner/26.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======================token allocation end===================== */}

        {/* ======================road map====================== */}
        <section>
          <div className="road-map cpy-6">
            <div className="container">
              <div className="row">
                <div className="sec-title text-center">
                  <h2 className="l-title">Road Map Myhilight & Unity Token</h2>
                </div>
              </div>

              <div className="road-map-area">
                <div className="row">
                  <div className="col-lg-8">
                    <div className="road-map-content">
                      <div className="road-map-inner">
                        <div className="road-map-img">
                          <img src="assets/img/solutions/10.png" alt="" />
                        </div>
                        <div className="road-map-text">
                          <p className="road-map-text">
                            NFT platform goes live March 20th
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-end">
                  <div className="col-lg-8">
                    <div className="road-map-content">
                      <div className="road-map-inner">
                        <div className="road-map-text">
                          <p className="road-map-text">
                            1st 100 students create an NFT’s February 30th
                          </p>
                        </div>
                        <div className="road-map-img-end">
                          <img src="assets/img/solutions/11.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-8">
                    <div className="road-map-content">
                      <div className="road-map-inner">
                        <div className="road-map-img">
                          <img src="assets/img/solutions/12.png" alt="" />
                        </div>
                        <div className="road-map-text">
                          <p className="road-map-text">
                            Presale of Unity Tokens March 15th
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-end">
                  <div className="col-lg-8">
                    <div className="road-map-content">
                      <div className="road-map-inner">
                        <div className="road-map-text">
                          <p className="road-map-text">
                            First 100 athletes sign up to MyHilight platform
                            March 15th
                          </p>
                        </div>
                        <div className="road-map-img-end">
                          <img src="assets/img/solutions/13.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-8">
                    <div className="road-map-content">
                      <div className="road-map-inner">
                        <div className="road-map-img">
                          <img src="assets/img/solutions/14.png" alt="" />
                        </div>
                        <div className="road-map-text">
                          <p className="road-map-text">
                            First 100 athletes sign up to MyHilight platform
                            March 15th
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-end">
                  <div className="col-lg-8">
                    <div className="road-map-content">
                      <div className="road-map-inner">
                        <div className="road-map-text">
                          <p className="road-map-text">
                            Unity Token goes live on Decentralized Exchanges
                            April 1st
                          </p>
                        </div>
                        <div className="road-map-img-end">
                          <img src="assets/img/solutions/15.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======================road map end====================== */}
        {/* ===========================token allocation================= */}
        <section>
          <div className="token-allocation cpy-6">
            <div className="container">
              <div className="row">
                <div class="col-lg-6 mb-4 mb-4">
                  <div class="cases-content">
                    <div class="content-inner">
                      <h2 class="about-title">Token Allocation</h2>
                      <ul class="cases-list">
                        <li>
                          <p>
                            To add new businesses and individuals to our
                            ecosystem to increase value and of Myhilight’s
                            valuation.
                          </p>
                        </li>
                        <li>
                          <p>
                            Update our applications with new enhancements for
                            customers experience, automate services, and
                            monetize customer interaction.
                          </p>
                        </li>
                        <li>
                          <p>
                            Launch a global exchange to create liquidity for
                            customer base, NFT’s and cryptocurrencies. Launch a
                            cryptocurrency for pairs in customers ecosystems and
                            NFT transactions.
                          </p>
                        </li>
                        <li>
                          <p>
                            Add additional use new cases to add value for Unity
                            Token & Myhilight
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 mb-4">
                  <div className="allocation-img">
                    <img src="assets/img/inner/27.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ===========================token allocation end================= */}
        {/* ==================conclusion===================== */}
        <section>
          <div className="conclusion">
            <div className="container">
              <div class="row justify-content-center">
                <div className="col-lg-8">
                  <div class="sec-title-n">
                    <h2 class="mb-3">Conclusion</h2>
                    <p>
                      Myhilight.com is created from experience with proven
                      concepts and best practices and signifies fundamental
                      advancements in bringing blockchain technology to youth.
                      Our ecosystem is part of an all-inclusive design for a
                      globally scalable NFT blockchain society in which
                      decentralized applications and digital currencies can be
                      easily deployed and administered. We will empower teens
                      around the world and bring them into the world of
                      cryptocurrency.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="conclusion-inner">
                    <ul className="conclusion-list">
                      <li>
                        <a href="" className="custom-btn">
                          <span>Videos</span>
                        </a>
                      </li>
                      <li>
                        <a href="" className="custom-btn">
                          <span>Sports</span>
                        </a>
                      </li>
                      <li>
                        <a href="" className="custom-btn">
                          <span>Music</span>
                        </a>
                      </li>
                      <li>
                        <a href="" className="custom-btn">
                          <span>Art</span>
                        </a>
                      </li>
                      <li>
                        <a href="" className="custom-btn">
                          <span>Collectables</span>
                        </a>
                      </li>
                      <li>
                        <a href="" className="custom-btn">
                          <span>Photography</span>
                        </a>
                      </li>
                      <li>
                        <a href="" className="custom-btn">
                          <span>Utility Business</span>
                        </a>
                      </li>
                      <li>
                        <a href="" className="custom-btn">
                          <span>Virtual Worlds</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6 mb-4">
                  <div className="conclusion-img">
                    <img src="assets/img/inner/28.png" alt="" />
                  </div>
                </div>
                <div class="col-lg-6 mb-4 mb-4">
                  <div class="cases-content">
                    <div class="content-inner">
                      <h2 class="about-title">Token Allocation</h2>
                      <p>
                        You can get Etherium, the Crypto currency that fuels
                        transactions on the Ethereum blockchain, from a digital
                        currency exchange like Binance or Coinbase. You will
                        need ETH to "mint" an NFT, purchase an NFT, and for gas
                        fees to complete transactions. Gas fees are a bit of a
                        tricky concept, but we simplify the basics here. Here
                        are a couple of articles about Gas fees explanation -
                        https://www.coindesk.com/learn/what-are-ethereum-gas-fees
                        and https://ethereum.org/en/developers/docs/gas/ Now
                        that you have ETH, let's get a cryptocurrency wallet.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* =============================conclusion end============ */}
        {/* ===================crypto area===================== */}
        <section>
          <div className="crypto">
            <div className="container">
              <div className="row col-revers-m">
                <div className="col-lg-6 mb-4">
                  <div class="cases-content">
                    <div class="content-inner">
                      <h2 class="about-title">Crypto Currency Wallet</h2>
                      <p>
                        A crypto currency wallet, such as MetaMask, stores your
                        ETH and routes transactions on the Ethereum blockchain.
                        Exclusive wallet addresses will be created and you will
                        use this address to finish transactions.
                      </p>
                      <p>
                        Every time one uses the Etherium blockchain transactions
                        connected to your wallet address can be found on
                        etherscan.io. After you complete your transaction check
                        Etherscan.io after completing every transaction.
                      </p>
                      <p>Do you need a wallet before selling on MyHilight?</p>
                      <p>
                        Just like a cryptocurrency trans action MyHilight is a
                        way to bring your transactions to the BlockChain. Our
                        Platform is a peer to peer exchange platform so entities
                        can move NFT’s from one place on the blockchain to
                        another. In order to Move your NFT you will need a
                        wallet to do that. Click here to learn about wallets
                        that work in our system.
                      </p>
                      <p>
                        When your wallet is installed you can connect to
                        <a href="">MyHilight.com</a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="wallet-img">
                    <img src="assets/img/inner/29.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ===================crypto area end===================== */}
        {/* ====================hilight=================== */}
        <section>
          <div className="hilight-area cpt-5">
            <div className="container">
              <div class="row justify-content-center">
                <div className="col-lg-8">
                  <div class="sec-title-n">
                    <h2 class="mb-3">MyHilight</h2>
                    <p>
                      When your wallet is finished, it is time to interact in
                      MyHilight. At that moment start adding your NFT’s and
                      customize your store. Your profile photo and cover banner
                      can be customized on your account as well.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ====================hilight=================== */}
        {/* ===================crypto area===================== */}
        <section>
          <div className="crypto cpy-6">
            <div className="container">
              <div className="row col-revers-m">
                <div className="col-lg-6 mb-4">
                  <div class="cases-content">
                    <div class="content-inner">
                      <h2 class="about-title">NFT Market without Gas Fees</h2>
                      <p>
                        MyHilight’s focus is working with highschool and college
                        kids. Some kids not having their own income we have to
                        create an option a gas-free marketplace on the Polygon
                        blockchain. Yes we have an ability to mint NFT’s and
                        make trades without occurring gas fees. So you go from
                        beginning to end and sell your NFT without incurring any
                        expenses.
                      </p>
                      <p>Verbiage To Place on Site – look at MyHilight.com</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  <div className="wallet-img">
                    <img src="assets/img/inner/30.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ===================crypto area end===================== */}
      </div>

      {/* ======================nft store============== */}
      <section>
        <div className="create-nft">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mb-4">
                <div className="wallet-img">
                  <img src="assets/img/inner/31.png" alt="" />
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div class="cases-content">
                  <div class="content-inner">
                    <h2 class="about-title">Create Your NFT Store</h2>
                    <p>
                      Create a store that reflects your brand inside of your own
                      ecosystem and position your business to benefit from a
                      trillion dollar a day industry.  Our website is designed
                      for consumers to customization.  NFT stores are able to
                      integrate with social media profiles consumer base
                      marketing.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ======================nft store end============== */}

      {/* ======================industry============== */}
      <section>
        <div className="create-nft cpy-6">
          <div className="container">
            <div className="row col-revers-m">
              <div className="col-lg-6 mb-4">
                <div class="cases-content">
                  <div class="content-inner">
                    <h2 class="about-title">The NFT Industry</h2>
                    <p>
                      At Myhilight, we understand the hard work it takes to
                      become a brand influencer, celebrity, or have a business
                      brand. Your hard work should be able to be monetized. The
                      NFT industry has blossomed into a billion-dollar industry
                      and will later be a trillion-dollar industry. People with
                      influence can position themselves to be at the forefront
                      of a new frontier of wealth and ownership.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div className="wallet-img">
                  <img src="assets/img/inner/32.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ======================nft store end============== */}

      {/* ======================nft store============== */}
      <section>
        <div className="create-nft">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mb-4">
                <div className="wallet-img">
                  <img src="assets/img/inner/33.png" alt="" />
                </div>
              </div>
              <div className="col-lg-6 mb-4">
                <div class="cases-content">
                  <div class="content-inner">
                    <h2 class="about-title">NFT Use Cases</h2>
                    <p>
                      We are partnering with celebrities in different industries
                      to create an adoption of our Tokenization & NFT's. Our
                      client will have personalized stores that will connect
                      with their consumer base to promote their products.
                      Influencers will be able to create a Hilight  and capture
                      that moment in video or photo and monetize it as an NFT. 
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ======================nft store end============== */}

      {/* ===========================about================= */}
      <section>
        <div class="hilight-area cpy-6">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <div class="sec-title-n">
                  <h2 class="mb-3">About</h2>
                  <p>
                    At MyHilight, we understand the hard work it takes to become
                    a brand influencer, celebrity, or have a business brand.
                    Your hard work should be able to be monetized. The NFT
                    industry has blossomed into a billion-dollar industry and
                    will later be a trillion-dollar industry. People with
                    influence can position themselves to be at the forefront of
                    a new frontier of wealth and ownership.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Home2;
